var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 14,
    viewBox: "0 0 40 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1871 0.231594L9.95042 12.9164H6.53375L3.95667 2.7935C3.80021 2.17 3.66417 1.94158 3.18833 1.67889C2.41167 1.25082 1.12875 0.849599 0 0.600451L0.0766667 0.231805H5.57646C6.2775 0.231805 6.90771 0.705567 7.06687 1.52513L8.42792 8.86506L11.7917 0.231594H15.1871ZM28.5744 8.77475C28.5881 5.4269 24.0144 5.24247 24.0458 3.74695C24.0556 3.2918 24.4825 2.80789 25.4169 2.68437C25.88 2.62282 27.156 2.57587 28.6033 3.25204L29.171 0.56217C28.3933 0.275797 27.3927 0 26.1477 0C22.9529 0 20.7046 1.72416 20.6856 4.19301C20.665 6.01911 22.2904 7.03812 23.515 7.64491C24.7748 8.2663 25.1975 8.66562 25.1927 9.22144C25.1837 10.0723 24.1879 10.4479 23.2573 10.4627C21.6327 10.4881 20.69 10.0165 19.9385 9.66179L19.3527 12.4407C20.1079 12.7924 21.5019 13.0993 22.9471 13.1148C26.3427 13.1145 28.564 11.412 28.5744 8.77475ZM37.0106 12.9164H40L37.3906 0.231594H34.6315C34.011 0.231594 33.4877 0.598336 33.256 1.1622L28.4056 12.9164H31.7996L32.4735 11.0215H36.6204L37.0106 12.9164ZM33.4042 8.42176L35.1054 3.65918L36.0846 8.42176H33.4042ZM19.8054 0.231594L17.1327 12.9164H13.9006L16.5744 0.231594H19.8054Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.189781daaad6a1977a5abd3f8b552698.svg";
export { ForwardRef as ReactComponent };